module.exports = require('@core/util/object');



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/marketing-campaigns_deploy_trigger_imp_v2/package/node_modules/@component/common/src/util/ObjectUtil.js